export default __webpack_public_path__ + "static/media/060.2ceef971.jpg";